/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 * @author Evgeniy Naumov
 * @version 1.22.0
 * @since 1.22.0
 */

import { IPageReportsConstructorTranslation } from '@modules/internationalization/types';

import { EConstructorItem, EConstructorReportsNew } from '../constants';
import { IReportsConstructorSelectedItem } from '../types';

export const setOrderReportTooltip = (
    translation: IPageReportsConstructorTranslation,
    selectedItem: IReportsConstructorSelectedItem | null,
    subscribersCount: number,
) => {
    if (!subscribersCount) {
        return translation.footer.tooltip.selectSubs;
    }

    if (!selectedItem) {
        return translation.footer.tooltip.selectReport;
    }
    return '';
};

export const setCreateTemplateTooltip = (
    translation: IPageReportsConstructorTranslation,
    selectedItem: IReportsConstructorSelectedItem | null,
) => {
    if (!selectedItem) {
        return translation.footer.tooltip.selectReport;
    }

    if (
        !EConstructorReportsNew[selectedItem.reportType as EConstructorReportsNew] &&
        selectedItem.itemType !== EConstructorItem.TEMPLATE
    ) {
        return translation.footer.tooltip.templateWithAdditionalReport;
    }

    if (selectedItem.itemType === EConstructorItem.TEMPLATE) {
        return translation.footer.tooltip.templateWithTemplateReport;
    }
    return '';
};
